import logo from './logo.png'
import linkedin_icon from './linkedin_icon.png'
import profile_image from './profile_image.png'
import facebook_icon  from './facebook_icon.png'
import twitter_icon  from './twitter_icon.png'
import whatsapp_icon from './whatsapp_icon.svg'
import telegram_icon from './telegram_icon.svg'
import phone_icon from './phone_icon.svg'
import email_icon from './email_icon.svg'
import location_icon from './location_icon.svg'
import asrqot from './asrqot.png'
import asrqot1 from './asrqotNext.png'


export const assets ={
    logo,
    profile_image,
    facebook_icon,
    twitter_icon,
    linkedin_icon,
    whatsapp_icon,
    telegram_icon,
    phone_icon,
    email_icon,
    location_icon,
    asrqot,
    asrqot1
}

export const url = 'http://localhost:5000'